<div
  class="bg-gradient-main min-vh-100 d-flex flex-row align-items-center"
  data-theme="dark"
>
  <c-container>
    <c-row class="justify-content-center">
      <c-col md="8">
        <div class="auth-layout">
          <div class="auth-hero d-none d-lg-flex text-center">
            <div class="auth-hero-content">
              <img
                src="assets/img/brand/SAGEL_SMALL.svg"
                class="mb-4 brand-logo"
                alt="Logo"
              />
              <h2 class="auth-title">Sign up</h2>
              <p class="auth-subtitle">
                Sign up for our app now and let our digital agent be the right
                hand of your company!
              </p>
              <a
                class="btn btn--primary-gradient w-100 mt-3"
                [routerLink]="['/register']"
                role="button"
              >
                Register Now!
              </a>
            </div>
          </div>

          <c-card class="auth-card">
            <c-card-body class="p-4">
              <div class="auth-mobile-brand d-lg-none text-center mb-4">
                <img
                  src="assets/img/brand/SAGEL_SMALL.svg"
                  class="mb-3 brand-logo"
                  alt="Logo"
                />
                <p class="auth-mobile-tagline">
                  Smart booking solutions for modern teams.
                </p>
              </div>

              <form cForm (ngSubmit)="login()">
                <h1 class="auth-title mb-1 text-center text-lg-start">Login</h1>
                <p class="muted mb-4 text-center text-lg-start">
                  Sign in to your account
                </p>

                @if (errorMessage) {
                <c-alert
                  color="danger"
                  class="modern-alert d-flex align-items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    fill="currentColor"
                    class="flex-shrink-0 me-2"
                    viewBox="0 0 16 16"
                    role="img"
                    aria-label="Warning:"
                  >
                    <path
                      d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                    />
                  </svg>
                  <div>{{ errorMessage }}</div>
                </c-alert>
                }

                <div class="auth-field mb-3">
                  <label for="login-username">Username</label>
                  <c-input-group class="auth-input">
                    <span cInputGroupText aria-hidden="true"
                      ><svg cIcon name="cilUser"></svg
                    ></span>
                    <input
                      id="login-username"
                      [(ngModel)]="email"
                      name="email"
                      autoComplete="username"
                      cFormControl
                      placeholder="Enter your username"
                    />
                  </c-input-group>
                </div>

                <div class="auth-field mb-4">
                  <label for="login-password">Password</label>
                  <c-input-group class="auth-input">
                    <span cInputGroupText aria-hidden="true"
                      ><svg cIcon name="cilLockLocked"></svg
                    ></span>
                    <input
                      id="login-password"
                      [(ngModel)]="password"
                      name="password"
                      autoComplete="current-password"
                      cFormControl
                      placeholder="Enter your password"
                      type="password"
                    />
                  </c-input-group>
                </div>

                <div class="auth-actions">
                  <button
                    type="submit"
                    cButton
                    class="btn--primary-gradient w-100"
                  >
                    Login
                  </button>
                  <button
                    type="button"
                    cButton
                    class="link-quiet"
                    color="link"
                    [routerLink]="['/forgot-password']"
                  >
                    Forgot password?
                  </button>
                </div>
              </form>
            </c-card-body>
          </c-card>
        </div>
      </c-col>
    </c-row>
  </c-container>
</div>
